import { StyleSheet } from 'react-native';
import { Colors } from 'react-native-paper';
import { appColors } from '../../../assets/styles/global';
import { pixelDimensions } from '../../../config/utils';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  title: {
    fontFamily: 'MBold',
    fontSize: pixelDimensions(5),
    marginVertical: pixelDimensions(2),
  },
  baseButtomSelected: {
    width: pixelDimensions(90),
    backgroundColor: appColors.primary,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: pixelDimensions(1),
    marginVertical: pixelDimensions(1),
    borderRadius: pixelDimensions(4),
  },
  baseButtom: {
    width: pixelDimensions(90),
    backgroundColor: Colors.blueGrey600,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: pixelDimensions(1),
    marginVertical: pixelDimensions(1),
    borderRadius: pixelDimensions(4),
  },
  viewTextButton: {
    flex: 1,
    alignSelf: 'center',
    alignItems: 'center',
    textAlign: 'center',
    flexWrap: 'wrap',
    paddingHorizontal: pixelDimensions(4),
    paddingVertical: pixelDimensions(2),
  },
  textButton: {
    textAlign: 'center',
    color: appColors.white,
    fontSize: pixelDimensions(4),
  },
  textButtonNext: {
    textAlign: 'center',
    color: Colors.white,
    fontSize: pixelDimensions(6),
  },
  buttonNext: {
    backgroundColor: appColors.primary,
    marginVertical: pixelDimensions(2),
    paddingVertical: pixelDimensions(2),
  },
});

export default styles;
